export const columns = [
	{ id: 'id', label: 'ID', hidden: true, width: '310px' },
	{
		id: 'employeeId',
		label: 'ID Empleado',
		hidden: true,
		width: '310px',
	},
	{ id: 'name', label: 'Nombre', width: '240px' },
	{ id: 'puesto', label: 'Puesto', width: '150px' },
	{ id: 'sector', label: 'Sector', width: '150px' },
	{
		id: 'statusDoctor',
		label: 'Estatus médico',
		width: '200px',
	},
	{ id: 'statusRH', label: 'Estatus RH', width: '200px' },
	{ id: 'doctorApprover', label: 'Médico Aprobador', width: '200px' },
	{ id: 'hrApprover', label: 'RH Aprobador', width: '200px' },

	{ id: 'results', label: 'Resultados', width: '250px' },
	{ id: 'serviceRequest', label: 'Folios', width: '200px' },
	{ id: 'certifiedFile', label: 'Aptitud', width: '130px' },
	{ id: 'customBusinessName', label: 'Razón social', width: '250px' },
	{
		id: 'destinationBranchOffice',
		label: 'Sucursal',
		width: '200px',
	},
	{ id: 'phone', label: 'Teléfono', width: '200px' },
	{ id: 'email', label: 'Correo', width: '500px' },
	{ id: 'createdBy', label: 'Responsable RH', width: '500px' },
	{ id: 'createdAt', label: 'Candidato Creado', width: '180px' },
	{
		id: 'labRequestedAt',
		label: 'Laboratorio Solicitado',
		width: '220px',
	},
	{
		id: 'externalOrderCreatedAt',
		label: 'Folio Creado',
		width: '150px',
	},
	{
		id: 'resultReceivedAt',
		label: 'Resultado Recibido',
		width: '200px',
	},
	{
		id: 'doctorApprovalAt',
		label: 'Aprobación del Médico',
		width: '220px',
	},
];
